import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Layout from '../Layout';
import Header from './Header';
import Body from './Body';
import { useSocket } from '../../Context/SocketContext';
import { useLocation, useParams } from 'react-router-dom';
import { listViewMapping } from '../Constants';
import { useAuth } from '../../Context/AuthContext';

const SavedNotes = () => {
  const [allNotes, setAllNotes] = useState([]);
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [filteredText, setFilteredText] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const { type } = useParams();

  const socket = useSocket();
  const { setTopLevelError } = useAuth();

  const handleDelete = useCallback(
    note => {
      if (!socket) return;
      socket.emit(listViewMapping[type].deleteEventName, note);
      setAllNotes(prev => prev.filter(n => n.key !== note.key));
      //setAllNotes(allNotes.filter(n => n.id !== note.id));
    },
    [socket, type]
  );

  useEffect(() => {
    if (!filteredText) {
      setFilteredNotes(allNotes);
      return;
    }

    const filtered = allNotes.filter(
      note =>
        note?.name?.toLowerCase()?.includes(filteredText.toLowerCase()) ||
        note?.courseName?.toLowerCase()?.includes(filteredText.toLowerCase())
    );

    setFilteredNotes(filtered);
  }, [filteredText, allNotes]);

  useEffect(() => {
    if (!socket) return;

    socket.emit(listViewMapping[type].retrieveEventName);

    socket.on(listViewMapping[type].retrieveEventName, data => {
      const { success, payload } = data;

      if (success) {
        setAllNotes(payload);
      } else {
        setTopLevelError('Error occured while retrieving from database!');
      }

      setIsLoading(false);
    });

    // if (type === '/savedNotes') {
    //   socket.emit('getSavedNotes');

    //   socket.on('getSavedNotes', notes => {
    //     setAllNotes(notes);
    //     setIsLoading(false);
    //   });
    // } else if (type === '/savedQuizzes') {
    //   socket.emit('getSavedQuizzes');

    //   socket.on('getSavedQuizzes', quizzes => {
    //     setAllNotes(quizzes);
    //     setIsLoading(false);
    //   });
    // }

    // socket.emit('getSavedNotes');

    // socket.on('getSavedNotes', notes => {
    //   setAllNotes(notes);
    //   setIsLoading(false);
    // });

    return () => {
      // if (type === '/savedNotes') {
      //   socket.off('getSavedNotes');
      // }
      // if (type === '/savedQuizzes') {
      //   socket.off('getSavedQuizzes');
      // }
      socket.off(listViewMapping[type].retrieveEventName);
      setAllNotes([]);
      setFilteredNotes([]);
      setFilteredText('');
      setIsLoading(true);
    };
  }, [socket, type]);

  return (
    <Layout
      header={useCallback(
        () => (
          <Header
            headingText={listViewMapping[type].heading}
            subHeadingText={listViewMapping[type].subHeading}
            setFilteredText={setFilteredText}
          />
        ),
        [type]
      )}
      body={useCallback(
        () => (
          <Body
            notes={filteredNotes}
            showSpinner={isLoading}
            handleDelete={handleDelete}
            pathname={type}
          />
        ),
        [filteredNotes, isLoading, handleDelete, type]
      )}
      hasGenericFooter={true}
      showBackgroundImage={true}
    />
  );
};

export default SavedNotes;
